var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { useMedia } from 'react-media-match';
import { Link, useLocation } from 'react-router-dom';
import Button from '../../Button';
import withErrorBoundary from '../../higherOrderComponents/withErrorBoundary';
import { withSkeleton } from '../../Skeleton';
import { ComponentThemeProvider } from '../../ThemeProvider';
import getIcon from '../../utils/getIcon';
import styled from '../../utils/styled-components';
import Skeleton from './skeleton';
import { breadcrumbTheme } from './theme';
var List = styled.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: block;\n  color: ", ";\n  font-size: ", ";\n"], ["\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: block;\n  color: ", ";\n  font-size: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.component.breadcrumb.color;
}, function (_a) {
    var theme = _a.theme;
    return theme.component.breadcrumb.font.size;
});
var ListItem = styled.li(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-block;\n  padding: 0;\n  margin: 0;\n\n  &:last-of-type {\n    font-weight: bold;\n  }\n\n  &:not(:last-of-type)::after {\n    content: '", "';\n    padding: ", ";\n    font-size: ", ";\n    text-decoration: none;\n  }\n"], ["\n  display: inline-block;\n  padding: 0;\n  margin: 0;\n\n  &:last-of-type {\n    font-weight: bold;\n  }\n\n  &:not(:last-of-type)::after {\n    content: '", "';\n    padding: ", ";\n    font-size: ", ";\n    text-decoration: none;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.component.breadcrumb.divider;
}, function (_a) {
    var theme = _a.theme;
    return theme.component.breadcrumb.padding.base;
}, function (_a) {
    var theme = _a.theme;
    return theme.component.breadcrumb.font.size;
});
var ItemLink = styled(function (_a) {
    var asLink = _a.asLink, to = _a.to, children = _a.children, props = __rest(_a, ["asLink", "to", "children"]);
    return asLink ? (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(Link, __assign({ to: to }, props, { "data-testid": "breadcrumb-list-item-router-link" }), children)) : (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement("a", __assign({ href: to }, props, { "data-testid": "breadcrumb-list-item-link" }), children));
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: ", ";\n  display: inline-block;\n  color: ", ";\n  white-space: nowrap;\n  text-decoration: none;\n\n  &:hover,\n  &:focus {\n    color: ", ";\n    text-decoration: underline;\n  }\n"], ["\n  font-size: ", ";\n  display: inline-block;\n  color: ", ";\n  white-space: nowrap;\n  text-decoration: none;\n\n  &:hover,\n  &:focus {\n    color: ", ";\n    text-decoration: underline;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.component.breadcrumb.font.size;
}, function (_a) {
    var theme = _a.theme;
    return theme.component.breadcrumb.color;
}, function (_a) {
    var theme = _a.theme;
    return theme.component.breadcrumb.highlightColor.base;
});
var BackButton = styled(Button)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: inline-flex;\n  margin-right: 0.5rem;\n  vertical-align: middle;\n  > svg {\n    margin-right: 0.5rem;\n  }\n"], ["\n  display: inline-flex;\n  margin-right: 0.5rem;\n  vertical-align: middle;\n  > svg {\n    margin-right: 0.5rem;\n  }\n"])));
var ArrowLeft = getIcon('ArrowMiniLeft');
var BreadcrumbBase = function (_a) {
    var hitCount = _a.hitCount, _b = _a.asLink, asLink = _b === void 0 ? false : _b, backButton = _a.backButton, _c = _a.backButtonSize, backButtonSize = _c === void 0 ? 'small' : _c, _d = _a.data, _e = _d.breadCrumb, breadCrumb = _e === void 0 ? [] : _e, breadCrumbSchema = _d.breadCrumbSchema;
    var isMobile = useMedia({
        mobile: true,
        tablet: false,
        desktop: false,
    });
    // mobile -> item > ... > item > item
    var items = isMobile
        ? breadCrumb.filter(function (_, i) { return i === 0 || i > breadCrumb.length - 3; })
        : breadCrumb;
    var backLink = items.length ? items[items.length - 1].uriPath : '/';
    // Keep Parameters on Back Button
    var _f = useLocation(), hash = _f.hash, search = _f.search;
    return (React.createElement(ComponentThemeProvider, { theme: breadcrumbTheme },
        React.createElement(List, { "data-testid": "breadcrumb-list-wrapper" },
            backButton && !!backLink && (React.createElement(BackButton, { to: backLink + search + hash, 
                // asLink is asRouterLink at Button
                asRouterLink: asLink, asLink: !asLink, size: backButtonSize, layout: "default" },
                React.createElement(ArrowLeft, null),
                " ",
                React.createElement(FormattedMessage, { id: "breadcrumb.button.back", defaultMessage: "zur\u00FCck" }))),
            items.map(function (_a, index) {
                var name = _a.name, uriPath = _a.uriPath, id = _a.id;
                return (React.createElement(Fragment, { key: id },
                    React.createElement(ListItem, { "data-testid": "breadcrumb-list-item" }, !uriPath ? (React.createElement("b", null, name)) : (React.createElement(ItemLink, { asLink: asLink, title: name, to: uriPath }, name))),
                    // mobile -> item > ... > item > item
                    items.length !== breadCrumb.length && index === 0 && (React.createElement(ListItem, { "data-testid": "breadcrumb-list-item-dummy" }, "..."))));
            }),
            hitCount && React.createElement("b", null,
                " (",
                hitCount,
                ")")),
        breadCrumbSchema && (React.createElement("script", { type: "application/ld+json", "data-testid": "breadcrumb-schema", 
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: { __html: JSON.stringify(breadCrumbSchema) } }))));
};
export default withSkeleton(withErrorBoundary(BreadcrumbBase, function () { return null; }, function () { return null; }), Skeleton);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=index.js.map